import React from "react";

export default function Google_Notification() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Google_Notification</h2>
      <p>Route: /icons/google/notification</p>
    </div>
  );
}
